import gql from 'graphql-tag';

export default gql`
mutation($runQuery: Boolean!) {
  setRunBreadcrumbQuery(runQuery: $runQuery) @client
}
`;
